"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentHasElements = documentHasElements;
exports.queryAndIterateElements = queryAndIterateElements;
exports.equalizeHeight = equalizeHeight;
function documentHasElements(selector, callback) {
    var elements = document.querySelectorAll(selector);
    if (elements.length) {
        callback(elements);
        return true;
    }
    return false;
}
function queryAndIterateElements(selector, callback, parentNode) {
    var elements = (parentNode || document).querySelectorAll(selector);
    elements.forEach(callback);
}
function equalizeHeight(selector, rootElement) {
    var elements = (rootElement || document).querySelectorAll(selector);
    var maxHeight = 0;
    elements.forEach(function (element) {
        element.style.height = 'auto';
    });
    elements.forEach(function (element) {
        var elementHeight = element.offsetHeight;
        if (elementHeight > maxHeight) {
            maxHeight = elementHeight;
        }
    });
    elements.forEach(function (element) {
        element.style.height = maxHeight + 'px';
    });
}
